import { Route, Switch, useRouteMatch } from "react-router-dom";
import AdminLayout from "./AdminLayout";
import Tabs from "../components/organism/Tabs";
import CustomNavLinkProps from "../services/models/customTabProps.model";
import ErrorBoundary from "../components/global/ErrorBoundary";
import AdminContentLayout from "./AdminContentLayout";
import OnlineOrderActions from "../services/OnlineOrderActions";
import { useContext, useEffect, useState, Suspense, lazy } from "react";
import { ApplicationState } from "../services/context/ApplicationStateContext";
import useProfile from "../services/utils/custom hooks/useProfile";
import { useOktaAuth } from "@okta/okta-react";
import { PopUpContext } from "../services/context/popupContext";
import PatientSelectionPopup from "../components/popups/patientSelectionPopup";
import OrganizationAndClinicianSelection from "../components/popups/organizationAndClinicianSelectionPopup";
import useFeatureFlags from "../services/utils/custom hooks/Feature Flagging/useFeatureFlags";
import dataConstants from "../constants/dataConstants";
import TableLoadingFallback from "../components/global/LoadingIndicators/TableLoadingFallback";

// Lazy load heavy table component
const TestOrdersTable = lazy(() => import("../components/Tables/TestOrdersTable"));

function TabNavLayout({ tabs }: { tabs: CustomNavLinkProps[] }): JSX.Element {
  let match = useRouteMatch();
  const { getActionsForSection } = useFeatureFlags();
  const {
    state: { selectedOrganization, selectedPathLab, selectedPhysician }, dispatch
  } = useContext(ApplicationState);
  const { visible, setVisible, setPopUp, setPopUpTitle, setOnlineOrder } =
    useContext(PopUpContext);
  const oktaAuth = useOktaAuth();
  const { data, isLoading } = useProfile();
  const roles = data?.user?.roles ?? [];
  const [canCreateOrder, setCanCreateOrder] = useState<boolean>(false);

  // const orderActions = new OnlineOrderActions(
  //   selectedOrganization,
  //   selectedPhysician,
  //   roles,
  //   data?.user.id,
  //   selectedPathLab,
  //   undefined,
  //   oktaAuth?.authState?.accessToken?.accessToken
  // );
  // useEffect(() => {
  //   orderActions.allowedToCreateOrder().then((res) => {
  //     setCanCreateOrder(res);
  //   });
  // }, [selectedOrganization, selectedPathLab, selectedPhysician]);

  const openPaitentFlowPopup = () => {
    // setVisible(!visible);
    setPopUpTitle("Choose or Create a Patient");
    setPopUp(<PatientSelectionPopup oktaAuth={oktaAuth} />);
    setOnlineOrder?.(false);
  };
  const isPLUPhysician = roles.includes("Physician") && roles.includes("PathLab User");
  const isPhysicianOnly = (roles.length === 1 && roles.includes("Physician")) || isPLUPhysician;


  return (
    <AdminContentLayout
      pageTitle="Test Orders Table"
      subHeaderTitle="Test Orders"
      rightSectionClassName="overflow-auto"
      customButtons={
        roles.includes("PathLab User") && roles.length === 1
          ? []
          : [
            {
              buttonTheme: "primary",
              key: dataConstants.SectionActionKeys.NEW_ONLINE_ORDER,
              textInformation: {
                text: "New Online Order",
                fontWeight: "font-semibold",
                fontSize: "text-sm",
              },
              onClick: () => {
                dispatch({ type: "HIDE_INFO_SLIDER", payload: undefined });
                setVisible(!visible);
                setPopUpTitle(`Select ${roles?.includes('Collaborative Order Agreement') ? 'a PathLab' : ''} an organization ${isPhysicianOnly ? '' : 'and a clinician'}`);
                setPopUp(
                  <OrganizationAndClinicianSelection
                    handleNext={openPaitentFlowPopup}
                  />
                );
              },
              className: "mr-6",
              // disabled: canCreateOrder ? false : true,
            },
          ].filter((button) =>
            getActionsForSection("TEST_ORDERS").find(
              (action) => action.key === button.key
            )?.isActive
          )
      }
    >
      <div className="xs:px-3 md:px-5 overflow-auto">
        {data?.user?.roles?.includes("Physician") &&
          data?.user?.roles?.length === 1 && (
            <nav className="sticky top-[0px] bg-white flex flex-col justify-center z-[3]">
              <Tabs tabs={tabs} containerClassName="!mx-0" />
            </nav>
          )}

        <Suspense fallback={<TableLoadingFallback />}>
          <Switch>
            <Route exact path={`${match.path}`}>
              <ErrorBoundary>
                <div className="">
                  <TestOrdersTable />
                </div>
              </ErrorBoundary>
            </Route>
            <Route path={`${match.path}/referrals`}>
              <ErrorBoundary>
                <div className="">
                  <TestOrdersTable />
                </div>
              </ErrorBoundary>
            </Route>
            <Route path={`${match.path}/approvals`}>
              <div className="px-5">Approvals Orders table</div>
            </Route>
          </Switch>
        </Suspense>
      </div>
    </AdminContentLayout>
  );
}

export default TabNavLayout;
